module.exports = __webpack_public_path__ + "static/img/r3.4d8a753.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/r3.png
// module id = yV3p
// module chunks = 0